module.exports = __webpack_public_path__ + "img/exam-stat-background@1.5x.7d55f2e4.png";